import { useQuery } from "@tanstack/react-query";
import { fetchWorkforceMetrics } from "PFApp/booking/services/api";
import { WorkforceMetrics } from "PFApp/booking/types";
import { Filters, Value } from "PFTypes";
import { CalendarRange } from "PFTypes/calendar_range";
import { QueryOptions } from "PFTypes/request_options";

import { workforceMetricsKeys } from "./query_keys";

interface UseWorkforceMetrics {
  calendarRange: CalendarRange;
  filters?: Filters<Value>;
  previousSearchId: number;
  options?: QueryOptions<WorkforceMetrics>;
}

export const useWorkforceMetrics = ({
  calendarRange,
  filters,
  previousSearchId,
  options = {}
}: UseWorkforceMetrics) =>
  useQuery<WorkforceMetrics>({
    queryKey: workforceMetricsKeys.single(calendarRange, filters),
    queryFn: async (): Promise<WorkforceMetrics> => {
      const workforce = await fetchWorkforceMetrics({
        dateRange: calendarRange,
        filters,
        previousSearchId
      });

      return {
        billableUtilization: workforce.billableUtilization,
        totalUtilization: workforce.totalUtilization,
        totalAvailability: {
          availableMinutes: workforce.availableMinutes,
          nominalWorkingMinutes: workforce.nominalWorkingMinutes
        }
      };
    },
    retry: false,
    ...options,
    enabled: options.enabled ?? true
  });
